/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{SnappingCandidate as t}from"./SnappingCandidate.js";class e extends t{constructor({targetPoint:t,objectId:e,constraint:r,isDraped:s,layer:a}){super(t,r,s,1),this.objectId=e,this.layer=a}}export{e as FeatureSnappingCandidate};
